<template>
<div class="bg-white lg:mx-60">
    <div class="flex justify-between items-center mb-14 mx-4 md:px-4 pt-4 mx-auto">
	    <div class="flex items-center justify-center gap-2">
		   	<slot name="pre-header"></slot>
	    </div>

      <img src="../assets/images/sycamore_logo.svg" class="w-28 md:w-56">

      <div class="flex items-center justify-center gap-2">
		   	<slot name="post-header"></slot>
	    </div>
    </div>

    <div class="_w-[70vw] md:w-10/12 m-auto">
        <div class="mt-12 px-4 lg:px-12">
        	<slot></slot>

          <div class="text-center mt-4 pb-4">
              <!-- <p class="text-xs md:text-sm leading-6 font-semibold">
                  <span class="mr-2">1 |</span>
                  www.sycamore.ng
              </p> -->

              <p class="text-xs md:text-sm leading-6 font-semibold">
                  The Board: Bade Aluko | Adeola Azeez | Oliver Nnona
              </p>
              <p class="text-xs md:text-sm leading-6 font-semibold">
                  Executive Directors: Babatunde Akin-Moses | Onyinye Okonji | Mayowa Adeosun
              </p>
              <p v-if="contacts" class="text-xs md:text-sm leading-6 font-semibold">
                  {{ contacts.address }} | {{ contacts.contact_email }} | {{ contacts.customer_service_number }} | www.sycamore.ng
              </p>
          </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from "moment";
import Ripple from "@/components/Ripple";
import TokenInvalid from "@/components/TokenInvalid";
import {fetchInvestment, decideContract} from "@/api/investment";
import {getSycamoreContacts} from "@/api/contacts";

export default {
    name: 'Letter',
    components:{
        Ripple,
        TokenInvalid
    },

    data() {
        return {
            contacts: null,
        }
    },

    methods: {
        async getContacts(){
            const response = await getSycamoreContacts();
            this.contacts = response.data.contact;
        }
    },

    mounted() {
        this.getContacts();
    },
}
</script>
